// src/pages/Solutions.js
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactUsSection from '../components/ContactUsSection';

const Contact = () => {
  return (
    <div>
      <Header />
      <ContactUsSection />
      <Footer/>
    </div>
  );
};

export default Contact;
